(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      } 


      this.currentScrollTop = scrollTop;
    }

    hide() {
      /*this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();*/
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
        
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  new Swiper(document.querySelector(".hero-slider").querySelector(".swiper"), {
    // spaceBetween: 50,
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true,
    // },
    observer: true,
    // autoheight: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    // mousewheel: true,
    rewind: true,
    // loop: true,
    autoheight: true,
    speed: 2000,
    spaceBetween: 0,
    scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
    },
    autoplay: {
      delay: 6000,
      // disableOnInteraction: false,
      // pauseOnMouseEnter: true
    },
    keyboard: {
        enabled: true,
        onlyInViewport: false,
    },
    grabCursor: true
  });

  var swiper2 = new Swiper(".mySwiper2", {
    // direction: "vertical",
    // spaceBetween: 50,
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true,
    // },
    observer: true,
    // keyboard: {
    //   enabled: true,
    //   onlyInViewport: false,
    // },
    // mousewheel: true,
    rewind: true,
    autoheight: true,
    effect: 'fade',
    // nested: true,
    autoplay: {
      delay: 2500,
      // disableOnInteraction: false,
      // pauseOnMouseEnter: true
    },
    speed: 2000,
    noSwiping: true,
    allowTouchMove: false
  });


  // document.querySelector(".hero-slider").querySelector(".swiper").style.height = (document.querySelector(".hero-slider").querySelector(".swiper").offsetHeight/2) + "px";

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!window.remassCollectionLoadMoreInitialised) {
    window.remassCollectionLoadMoreInitialised = true;

    let loadMoreObserver;
    let refreshScheduled = false;

    const removeLegacyPagination = () => {
      document
        .querySelectorAll('.collection-grid-section .pagination-wrapper, #ProductGridContainer .pagination-wrapper')
        .forEach((pagination) => pagination.remove());
    };

    const observeLoadMoreButtons = () => {
      if (!('IntersectionObserver' in window)) return;

      if (!loadMoreObserver) {
        loadMoreObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              const button = entry.target;

              if (!button.isConnected) {
                loadMoreObserver.unobserve(button);
                return;
              }

              if (
                button.dataset.loading === 'true' ||
                button.dataset.autoLoadPaused === 'true' ||
                button.disabled
              ) {
                return;
              }

              loadMoreObserver.unobserve(button);
              button.click();
            });
          },
          {
            root: null,
            rootMargin: '0px 0px 800px 0px',
            threshold: 0
          }
        );
      }

      document.querySelectorAll('[data-load-more-button]').forEach((button) => {
        if (
          !button.isConnected ||
          button.dataset.loading === 'true' ||
          button.dataset.autoLoadPaused === 'true' ||
          button.disabled
        ) {
          return;
        }

        loadMoreObserver.observe(button);
      });
    };

    const refreshCollectionLoader = () => {
      removeLegacyPagination();
      observeLoadMoreButtons();
    };

    const scheduleRefresh = () => {
      if (refreshScheduled) return;

      refreshScheduled = true;

      window.requestAnimationFrame(() => {
        refreshScheduled = false;
        refreshCollectionLoader();
      });
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-load-more-button]');

      if (!button || button.dataset.loading === 'true') return;

      const nextPageUrl = button.dataset.nextPageUrl;

      if (!nextPageUrl) return;

      const wrapper = button.closest('.collection-load-more');
      const status = wrapper ? wrapper.querySelector('[data-load-more-status]') : null;
      const productGrid = document.getElementById('product-grid');

      if (!productGrid) return;

      if (loadMoreObserver) {
        loadMoreObserver.unobserve(button);
      }

      button.dataset.autoLoadPaused = 'false';
      button.dataset.loading = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = button.dataset.loadingText;

      try {
        const response = await fetch(nextPageUrl, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error(`Collection request failed with status ${response.status}`);
        }

        const responseText = await response.text();
        const nextDocument = new DOMParser().parseFromString(responseText, 'text/html');
        const newItems = nextDocument.querySelectorAll(
          '#product-grid > .grid__item__collection-product'
        );

        if (!newItems.length) {
          throw new Error('Collection response did not contain product cards');
        }

        if (!productGrid.isConnected) return;

        const fragment = document.createDocumentFragment();

        newItems.forEach((item) => {
          fragment.appendChild(item);
        });

        productGrid.appendChild(fragment);

        if (status) {
          status.textContent = `${newItems.length} ${button.dataset.loadedText}`;
        }

        const nextButton = nextDocument.querySelector('[data-load-more-button]');

        if (nextButton && nextButton.dataset.nextPageUrl) {
          button.dataset.nextPageUrl = nextButton.dataset.nextPageUrl;
          button.disabled = false;
          button.textContent = button.dataset.defaultText;
        } else if (wrapper) {
          wrapper.remove();
        }
      } catch (error) {
        console.error('[Remass collection load more]', error);

        button.dataset.autoLoadPaused = 'true';
        button.disabled = false;
        button.textContent = button.dataset.defaultText;

        if (status) {
          status.textContent = button.dataset.errorText;
        }
      } finally {
        button.dataset.loading = 'false';
        button.removeAttribute('aria-busy');
        scheduleRefresh();
      }
    });

    const collectionMutationObserver = new MutationObserver(() => {
      scheduleRefresh();
    });

    collectionMutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    refreshCollectionLoader();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-slider"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".mySwiper", {
    // spaceBetween: 50,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    observer: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    mousewheel: true,
    rewind: true,
    autoheight: true,
    speed: 400,
    // spaceBetween: 100,

  });
  var swiper2 = new Swiper(".mySwiper2", {
    direction: "vertical",
    // spaceBetween: 50,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    observer: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    mousewheel: true,
    rewind: true,
    autoheight: true,
    // speed: 400,
    spaceBetween: 100,
  });
  // const rotateButton = document.querySelector(".rotate-button");
  // rotateButton.addEventListener("click", () => {
  //   rotateButton.closest(".swiper-slide").classList.toggle("rotate");
  // });

  document.querySelectorAll(".icon-arrow-heart").forEach(element => {
    element.addEventListener("click", () => {
      swiper.slideNext(4000, true);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
